export interface PaymentMethod {
  id: number;
  name: string;
  status: string;
}

export interface PaymentMethods {
  id: string;
  code: string;
  name: string;
  is_active: Boolean;
}


// "id": "95",
// "payment_method_id": "1",
// "paid_at": null,
// "additional_data": null,
// "status": "pending",
// "billing_address_id": null,
// "reference_order_id": "29"

